/**
 * Whether a key was pressed in a field — an input, a text area, a select or anything editable —
 * whose own keys it is. The table's row keys and the split view's Esc both stand aside for one, so
 * both ask the same question here rather than each spelling it.
 */
export function isField(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName))
  );
}
